export const LUTS_TYPE_ID = 84;

export const LUTS_FILTER = 'is_lut:true';

export const EXCLUDE_LUTS_FILTER = 'is_lut:false';

export const LUTS_TYPE_FILTER = `types.id:=[${LUTS_TYPE_ID}]`;
